import Select from 'react-select'
import React, { useEffect, useState } from 'react'
// import { DailyPreventiveWorkTableDataAPI } from "../../../../Redux/GardenDashboardSlice/DailyPreventiveWorkSlice";
import moment from "moment";
import { useAuthState } from '../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { Loading } from '../../../../Helper/Loading';
import Header from '../../../../Components/Header/Header';
import Sidebar from '../../../../Components/Sidebar/Sidebar';
import { WardNameDataDDL } from '../../../../Components/CommonDDL/WardNameDataDDL';
import { WorkTypeDDL } from '../../../../Components/CommonDDL/WorkTypeDDL';
import { Pegination } from '../../../../Components/Pegination/Pegination';
import ViewURL from '../../../../Components/ViewURL/ViewURL';
import { FinancialYearHeaderDDL } from '../../../../Components/CommonDDL/FinancialYearHeaderDDL';
import { MonthHeaderDDL } from '../../../../Components/CommonDDL/MonthHeaderDDL';
import { useSearchParams } from 'react-router-dom';
import { PeriodWiseWorkAnalysisExport } from './PeriodWiseWorkAnalysisExport';
// import { PreventiveWorkReportTableDataAPI } from "../../../../Redux/ReportsSlice/PreventiveWorkReportSlice";
// import { PreventiveWorkReportExport } from "./PreventiveWorkReportExport";

export default function PeriodWiseWorkAnalysisReport() {


    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")

    // console.log(ApiFlag)

    const d = new Date();
    let month = d.getMonth();

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '1',
        Label: WLable && WLable ? WLable : "Select...",
    })
    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [FromMonth, setFromMonth] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [ToMonth, setToMonth] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })


    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward",
    // })

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [IsSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [ImageHeading, setImageHeading] = useState('')
    const [PDFUrl, setPDFUrl] = useState('')

    const handleClear = () => {
        setCurrentPage(0)
        setIsClear(!IsClear)
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
        setWardName({
            ...WardName,
            ID: WardName.DDL[0].value,
            Label: WardName.DDL[0].label,
        })
        setWorkType({
            ...WorkType,
            ID: 0,
            Label: 'Select...',
        })

        // console.log("call")
    }
    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [Month, setMonth] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    return (
        <>
            {/* {isLoading && <Loading />} */}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId} active='periodwiseworkanalysisreport' listActive="gardenReport" />
                    <div id="" className="content1 content">
                        <div className="data_mob">
                            <div className="row m-1 pb-4 master_border">
                                <div className="col-8">
                                    <h5 className="ps-1 py-2">Period Wise Work Analysis</h5>
                                </div>
                                <div className="col-4 mt-2">
                                    {/* <PeriodWiseWorkAnalysisExport
                                        name='Period Wise Work Analysis'
                                        // ExcelData={tableData}
                                        WardName={WardName}
                                        FromDate={FromDate}
                                        ToDate={ToDate}
                                    />
                                     <button type="button" className="btn btn-danger float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                                        // onClick={handleOpenPdf}
                                    ><i className='fas fa-file-pdf mx-2'></i>PDF</button> */}
                                </div>
                                <div className="row m-0">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                        <div className="col-12">
                                            <div className="row py-1 rounded2">
                                                
                                                <div className="col-lg-2 col-md-4">
                                                <label for=""><b>From Month :</b></label>
                                                <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    // className="ddl_width"
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: FromMonth.ID, label: FromMonth.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setFromMonth({ ...FromMonth, ID: e.value, Label: e.label })
                                                            :
                                                            setFromMonth({ ...FromMonth, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={FromMonth.DDL}
                                                />

                                            </div>
                                            <div className="col-lg-2 col-md-4">
                                                <label for=""><b>To Month :</b></label>
                                                <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    // className="ddl_width"
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: ToMonth.ID, label: ToMonth.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setToMonth({ ...ToMonth, ID: e.value, Label: e.label })
                                                            :
                                                            setToMonth({ ...ToMonth, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={ToMonth.DDL}
                                                />

                                            </div>
                                            <div className="col-12 col-md-4 col-lg-2">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        // HWard={HWard}
                                                        // WLable={WLable}
                                                        Flag='Ward'
                                                    />
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <WorkTypeDDL
                                                        WorkType={WorkType}
                                                        setWorkType={setWorkType}
                                                        isDisplay={true}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-2 mt-lg-4 mt-md-4 d-md-flex" >
                                                    <div className='d-flex'>
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        // onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mob_table table-responsive pt-1">
                                                <table
                                                    id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Work Type</th>
                                                            <th>Work Assign Count</th>
                                                            <th>Work Completed in Time</th>
                                                            <th>Work Defaulter Count</th>
                                                            <th>Work Pending</th>
                                                            <th>Penalty Charged (Rs.)</th>
                                                            {/* <th>Work Sub Type</th>
                                                            <th>Before Work <br />Photo</th>
                                                            {
                                                                searchName == 'Completed' ?
                                                                    <th>After Work <br />Photo</th>
                                                                    :
                                                                    <></>
                                                            } */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <td className='text-center'>1</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>

                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* {tableData && tableData.table && tableData.table.length > 0 && */}
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                // TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                            {/* } */}

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </>

    )

}